/**
 * @generated SignedSource<<c36ef96607dd0a949a99b9287512b691>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreativeType = "TEXT_BUTTON" | "TEXT_IMAGE" | "TEXT_IMAGE_BUTTON";
export type ErrorType = "ERR_ADSLOT" | "ERR_CARD_BIRTH" | "ERR_CARD_EXPIRED" | "ERR_CARD_NUMBER" | "ERR_CARD_PASSWORD" | "ERR_CARD_PASSWORD_FIVE_TIMES" | "ERR_CREATE_SURVEY_ANSWER" | "ERR_DUPLICATE_APPLY" | "ERR_ETC" | "ERR_EXIST_FINISH_REFUND" | "ERR_EXIST_SEARCH_HISTORY" | "ERR_EXPIRE_URL" | "ERR_HECTO_ETC" | "ERR_HOMETAX_BLOCK_ID" | "ERR_HOMETAX_CALCULATE" | "ERR_HOMETAX_COLLECT" | "ERR_HOMETAX_ETC" | "ERR_HOMETAX_EXPIRE_CERT" | "ERR_HOMETAX_IMPOSSIBLE" | "ERR_HOMETAX_INPUT" | "ERR_HOMETAX_NO_BMAN" | "ERR_HOMETAX_NO_CONTINUE_BMAN" | "ERR_HOMETAX_NO_CORPS_ID" | "ERR_HOMETAX_NO_INCOME_TAX" | "ERR_HOMETAX_NO_JUMIN_ID" | "ERR_HOMETAX_NO_REGIST_CERT" | "ERR_HOMETAX_NO_USER" | "ERR_HOMETAX_OVERLOAD" | "ERR_HOMETAX_PASSWORD" | "ERR_HOMETAX_PASSWORD_CHANGE_REQUEST" | "ERR_HOMETAX_REG_NO" | "ERR_HOMETAX_SERVER_FIX" | "ERR_HOMETAX_SESSION" | "ERR_HOMETAX_SIMPLE_AUTH" | "ERR_HOMETAX_TIMEOUT" | "ERR_LEAVE_REASON" | "ERR_LEAVE_REASON_LOG" | "ERR_NON_PRODUCT_PROMOTION" | "ERR_NOT_EXIST_HISTORY" | "ERR_NOT_EXIST_YEAR_END_TAX_SETTLEMENT" | "ERR_NO_EQUAL_TIN" | "ERR_PROMOTION" | "ERR_SSO" | "ERR_SURVEY" | "ERR_SURVEY_ANSWER" | "ERR_SURVEY_COMPLETED" | "ERR_SURVEY_EXPIRED" | "ERR_UPDATE_SURVEY_ANSWER" | "ERR_USER" | "ERR_USER_ACTION_LOG" | "ERR_USER_PHONE";
export type PlacementType = "HOME_BOTTOM_BENEFIT_1" | "HOME_BOTTOM_BENEFIT_2" | "HOME_BOTTOM_BENEFIT_3" | "HOME_BOTTOM_HELP" | "LOOKUP_RESULT" | "MY_PAGE_BOTTOM";
export type UtmInput = {
  campaign?: string | null | undefined;
  content?: string | null | undefined;
  medium?: string | null | undefined;
  source?: string | null | undefined;
  term?: string | null | undefined;
};
export type adSlotQuery$variables = {
  placementType: PlacementType;
  target: string;
  utm?: UtmInput | null | undefined;
  workingPlatform?: string | null | undefined;
};
export type adSlotQuery$data = {
  readonly getAdSlot: {
    readonly errors: {
      readonly code: ErrorType;
      readonly message: string | null | undefined;
    } | null | undefined;
    readonly items: ReadonlyArray<{
      readonly _id: number;
      readonly buttonText?: string;
      readonly creativeType: CreativeType;
      readonly description?: string | null | undefined;
      readonly displayCode: string;
      readonly displayRatio: number;
      readonly displayTitle?: string | null | undefined;
      readonly imagePath?: string;
      readonly linkUrl?: string;
      readonly userEvent: string | null | undefined;
    }> | null | undefined;
    readonly placementType: PlacementType | null | undefined;
    readonly result: boolean;
    readonly title: string | null | undefined;
  };
};
export type adSlotQuery = {
  response: adSlotQuery$data;
  variables: adSlotQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "placementType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "target"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "utm"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workingPlatform"
},
v4 = [
  {
    "kind": "Variable",
    "name": "placementType",
    "variableName": "placementType"
  },
  {
    "kind": "Variable",
    "name": "platform",
    "variableName": "workingPlatform"
  },
  {
    "kind": "Variable",
    "name": "target",
    "variableName": "target"
  },
  {
    "kind": "Variable",
    "name": "utm",
    "variableName": "utm"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "result",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Errors",
  "kind": "LinkedField",
  "name": "errors",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "placementType",
  "storageKey": null
},
v9 = {
  "alias": "_id",
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "creativeType",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayCode",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayRatio",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userEvent",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayTitle",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imagePath",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "buttonText",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkUrl",
  "storageKey": null
},
v19 = {
  "kind": "InlineFragment",
  "selections": [
    (v14/*: any*/),
    (v15/*: any*/),
    (v16/*: any*/),
    (v17/*: any*/),
    (v18/*: any*/)
  ],
  "type": "TextImageButtonAdSlotItem",
  "abstractKey": null
},
v20 = {
  "kind": "InlineFragment",
  "selections": [
    (v14/*: any*/),
    (v15/*: any*/),
    (v16/*: any*/),
    (v18/*: any*/)
  ],
  "type": "TextImageAdSlotItem",
  "abstractKey": null
},
v21 = {
  "kind": "InlineFragment",
  "selections": [
    (v14/*: any*/),
    (v15/*: any*/),
    (v17/*: any*/),
    (v18/*: any*/)
  ],
  "type": "TextButtonAdSlotItem",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "adSlotQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "GetAdSlotOutput",
        "kind": "LinkedField",
        "name": "getAdSlot",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "adSlotQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "GetAdSlotOutput",
        "kind": "LinkedField",
        "name": "getAdSlot",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "350842b8c622178f7453a924f6173eaf",
    "id": null,
    "metadata": {},
    "name": "adSlotQuery",
    "operationKind": "query",
    "text": "query adSlotQuery(\n  $placementType: PlacementType!\n  $workingPlatform: String\n  $target: String!\n  $utm: UtmInput\n) {\n  getAdSlot(placementType: $placementType, platform: $workingPlatform, target: $target, utm: $utm) {\n    result\n    errors {\n      code\n      message\n    }\n    title\n    placementType\n    items {\n      __typename\n      _id: id\n      creativeType\n      displayCode\n      displayRatio\n      userEvent\n      ... on TextImageButtonAdSlotItem {\n        displayTitle\n        description\n        imagePath\n        buttonText\n        linkUrl\n      }\n      ... on TextImageAdSlotItem {\n        displayTitle\n        description\n        imagePath\n        linkUrl\n      }\n      ... on TextButtonAdSlotItem {\n        displayTitle\n        description\n        buttonText\n        linkUrl\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e7c88d87e142df5df0757e2aec6e11a1";

export default node;
